import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './vuex/store';
let commonService = require('./services/common.service');
let utilities = require("./utilities/utilities");
let Encrypted = require("./services/encrypted");

Vue.use(VueRouter)




import LoginLayout from './layouts/loginLayout.vue'
import FormLayout from './layouts/formLayout.vue'
import PortalLayout from './layouts/portalLayout.vue'
import ReportLayout from './layouts/reportLayout.vue'
import DashboardLayout from './layouts/dashboardLayout.vue'
import Page404 from './components/page-404.vue'

import LoginPage from './components/security/login.vue'
import LogoutPage from './components/security/logoutPage.vue'
import UserPage from './components/user/users_table.vue'

import DashboardPage from './components/dashboard/dashboard.vue'

import ProfilePage from './components/user_profile/account_setting.vue'

import main_menu from './components/Menu/sysMenu_table.vue'
import sub_menu from './components/Submenu/sysSubmenu_table.vue'

import SysUserrole from './components/Userrole/sysUserrole_table.vue'
import RolePermission from './components/Userrole/setRolePermission.vue'

import userinfo from './components/userinfo/userinfo_table.vue'

import UserProfile from './components/profile/UserProfile'

// import by abu sabir ========================
import AssetCategory from './components/asset/asset_category/asset_cat_list.vue'
import AssetSubCategory from './components/asset/asset_sub_category/asset_sub_cat_list'
import AssetLocation from './components/asset/asset_location/asset_location_list'
import AssetMaster from './components/asset/asset_master/asset_master_list'
import AssetMovement from './components/asset/asset_movement/asset_movement_list'
import AssetItem from './components/asset/asset_item/asset_item_list'

import ParameterMaster from './components/report/parameter_master/parameter_master_list'
import ReportMaster from './components/report/report_master/report_master_list'
import ReportDetails from './components/report/report_details/report_details_list'
import ReportInterface from './components/report/report_interface/report_interface'

import VoucherMasterForm from './components/project_info/Voucher/voucher_form.vue'
import VoucherMaster from './components/project_info/Voucher/voucher_data.vue'

import EarlySettlement from './components/lending/early_settlement/early_settlement.vue'
import AuditDetails from './components/audit/auditDetails.vue'


import ProcurementMethod from './components/procurement/method/method_list'
/*-------------------- For Project Information Module --------------------*/
import DevlopmentPartner from './components/project_info/development_partner/partner_table.vue'
import OperationActivities from './components/project_info/operation_activities/operation_act_table.vue'
import OperationActivitiesForm from './components/project_info/operation_activities/activitiesForm.vue'
import CreditMaster from './components/project_info/credit_master/dataTable.vue'
import ImplementingAgency from './components/project_info/implement_agency/dataTable.vue'
import ProjectStaffInformation from './components/project_info/project_staff_info/dataTable.vue'

/*----------------- The same mvc has been used here --------------*/
import AccountInfo from './components/project_info/account_info/dataTable.vue'
import RepaymentAccountInfo from './components/lending/account_info/dataTable.vue'
/*----------------- /The same mvc has been used here --------------*/

import EconomyCodeInfo from './components/project_info/economy_code_info/dataTable.vue'
import VoucherType from './components/project_info/voucher_type/dataTable.vue'

import ProjectBudget from './components/project_info/project_budget/dataTable.vue'
import ProjectBudgetDetail from './components/project_info/project_budget/prject_bud_details/dataTable.vue'

import MidTermProjectBudget from './components/project_info/mid_term_project_budget/dataTable.vue'
import MidTermProjectBudgetDetail from './components/project_info/mid_term_project_budget/prject_bud_details/dataTable.vue'

import YearlyProjectBudget from './components/project_info/yearly_project_budget/dataTable.vue'
import YearlyProjectBudgetDetail from './components/project_info/yearly_project_budget/yearly_pro_bud_details/dataTable.vue'

import ProjectForcustReport from './components/project_info/project_forcust_report/dataTable.vue'
import ProjectYearlyForecastReport from './components/project_info/project_forcust_report/listTable.vue'



import BipReport from './components/project_info/bip/dataTable.vue'
import BipReportInsertForm from './components/project_info/bip/insertForm.vue'

import BudgetWiseFundRelease from './components/project_info/budgetWiseFundRelease/dataTable.vue'
import BudgetWiseFundReleaseInsertForm from './components/project_info/budgetWiseFundRelease/insertForm.vue'

import Designation from './components/project_info/designation/dataTable.vue'
import AgencyDetails from './components/project_info/agency_details/dataTable.vue'
import PartnerDetails from './components/project_info/partner_details/dataTable.vue'
/*-------------------- /For Project Information Module --------------------*/

//#=========components are imported by majeed======================
//############### Training routes ################################
import TrainingCategory from './components/training/training_category/training_list'
import TrainingCostHead from './components/training/training_cost_head/training_cost_head_list'
import TrainingOrganizerInfo from './components/training/training_organizer_info/_organizer_list.vue'
import TrainingInfo from './components/training/training_information/training_info_list'
import TrainingInfoForm from './components/training/training_information/training_info_form'
import TrainingInfoDetails from './components/training/training_information/detailsView'

//================ Administration routes ===========================
import SubHead from './components/administration/sub_head_entry/sub_head_list.vue'
import SalaryCategory from './components/administration/salary_category_entry/salary_category_list'
import StaffEntry from './components/administration/staff_entry/staff_entry_list'
import OvertimeEntry from './components/administration/overtime_entry/overtime_entry_list'
import VehicleEntry from './components/administration/vehicle_info/vehicle_info_list'
import LeaveEntry from './components/administration/leave_entry/leave_entry_list'
import LeaveDetails from './components/administration/leave_entry/detailsLeave'
import LeaveCalendar from './components/administration/leave_entry/eventCalendar'
import VehicleExpiry from './components/administration/vehicle_info/vehicle_expiry_details'
import admSettings from './components/administration/settings/adm_setting.vue'
import salaryEntry from './components/administration/salary_entry/salary_entry_list'

/***************************** Document Management *********************************/
import DocumentInsertForm from './components/document_management/upload_document_form'
import DocumentList from './components/document_management/upload_document_list'
import ViewDocumentList from './components/document_management/view_upload_document'


//**************************** End import by majeed ****************

// Imports by M.A. Tariq
//Procurement module
import ProcurementMethods from './components/procurement/method/method_list.vue'
import ProcurementMethodSteps from './components/procurement/method_steps/method_steps_list.vue'
import ProcurementType from './components/procurement/type/type_list.vue'
import ProcurementThresholds from './components/procurement/thresholds/thresholds_list.vue'
import ReportNote from './components/procurement/thresholds/report_note_list.vue'
import ProcurementTypeEco from './components/procurement/type_eco/ecocode_list.vue'
import ProcurementStatus from './components/procurement/status/status_list.vue'
import ProcurementUnit from './components/procurement/unit_master/unit_list.vue'
import ProcurementContract from './components/procurement/contract_type/contract_list.vue'
import ProcurementSupplier from './components/procurement/supplier/supplier_list.vue'
import ProcurementPackage from './components/procurement/package/package_list.vue'
import ProcurementNewPackage from './components/procurement/package/packageForm.vue'
import ProcurementPackageRev from './components/procurement/package_revision/package_rev_list.vue'
import ProcurementRevision from './components/procurement/package_revision/packageRevForm.vue'
import ProcurementExecution from './components/procurement/execution/execution_list.vue'
import ProcurementExecutions from './components/procurement/execution/execution_data.vue'
import ProcurementExecutionForm from './components/procurement/execution/executionForm.vue'
import ProcurementVoucher from './components/procurement/voucher/voucher_list.vue'
import onlending_voucher_list from './components/procurement/voucher/onlending_voucher_list.vue'
import finance_voucher_list from './components/procurement/voucher/finance_voucher_list.vue'
import allVoucherList from './components/procurement/voucher/voucher_all_list.vue'
import PackageVersion from './components/procurement/package_version/dataTable.vue'
import TrainingVoucher from './components/procurement/voucher/training_voucher_list.vue'
import TrainingVoucherForm from './components/procurement/voucher/training_voucher_form.vue'
import AdminVoucher from './components/procurement/voucher/admin_voucher_list.vue'
import AdminVoucherForm from './components/procurement/voucher/admin_voucher_form.vue'


import PackageArchive from './components/procurement/package_archive/dataTable.vue'
import PackageArchiveDetails from './components/procurement/package_archive/details/dataTable.vue'
import PackageVieweDetails from './components/procurement/package/detailsView.vue'
import ExecutionVieweDetails from './components/procurement/execution/ExecutionVieweDetails.vue'

/*--------------------Voucher-------------------*/
import ProcVoucherMasterForm from './components/procurement/voucher/voucherForm.vue'
import FinanceVoucherForm from './components/procurement/voucher/finance_voucher_form.vue'
import OnlendingVoucherMasterForm from './components/procurement/voucher/onlending_voucher_form.vue'


/*--------------------For On Lending Module--------------------*/
import Sector from './components/lending/sector/sector/dataTable.vue'
import PartialPay from './components/lending/partial_pay/dataTable.vue'
import SubSector from './components/lending/sector/sub_sector/dataTable.vue'
import PfiInformation from './components/lending/PFI/dataTable.vue'
import ClientInformation from './components/lending/clientsupplier/clientInfo/dataTable.vue'
import Suppliernformation from './components/lending/clientsupplier/supplierInfo/dataTable.vue'
import InstallmentType from './components/lending/installmentType/dataTable.vue'
import Location from './components/lending/location/dataTable.vue'
import SubProjectInfo from './components/lending/subProjectInfo/dataTable.vue'

import LoanProfile from './components/lending/loanProfile/dataTable.vue'
import LoanProfActivitiesForm from './components/lending/loanProfile/activitiesForm.vue'
import LoanProfileDetail from './components/lending/loanProfile/viewDetail.vue'
import LoanReScheduleDetail from './components/lending/loanProfile/reScheduleOnly.vue'

import SearchDisbursement from './components/lending/disbursement/search_form'
import DisbursementForm from './components/lending/disbursement/insert_form'

import SearchLoanReset from './components/lending/loanReset/search_form.vue'
import InsertLoanReset from './components/lending/loanReset/insert_form.vue'

import SearchLoanReSchedule from './components/lending/loanReSchedule/search_form.vue'
import InsertLoanReSchedule from './components/lending/loanReSchedule/insert_form.vue'

//just for see
import PaymentSchedule from './components/lending/loanProfile/step_forms/loanProfileSchedule.vue'
import InstallmentCollection from './components/lending/installmentCollection/dataTable.vue'
import RePayment from './components/lending/installmentCollection/RePayment.vue'
//import OverdueInstallmentPayment from './components/lending/loanProfile/installmentCollection/overdueInstallment.vue'

//import OverdueInstallment from './components/lending/overdueInstallment/dataTable.vue'
//import OverdueInstallmentPayment from './components/lending/overdueInstallment/RePayment.vue'
import OverdueInstallmentPayment from './components/lending/installmentCollection/overDueInst.vue'
/*--------------------/For On Lending Module--------------------*/


/*------------------Module----------------*/
import ProjectInfoModule from './components/modules/project_info.vue'
/*------------------/Module----------------*/

/*--------------Report Generator Route File-------------*/
import ReportGeneratorRoute from "./reportGeneratorRouter.js"
/*--------------Report Generator Route File-------------*/

const routes = [
    ...ReportGeneratorRoute,

    {
        path: '/user',
        component: PortalLayout,
        children: [
            {
                path: '',
                name: 'Welcome to User Module',
                component: ProjectInfoModule
            },
            {
                path: 'userList',
                component: UserPage
            },
            {
                path: 'setting',
                component: ProfilePage
            },
            {
                path: 'profile',
                component: UserProfile
            },
            {
                path: 'role',
                component: SysUserrole
            },
            {
                path: 'permission',
                component: RolePermission
            },
        ]
    },


    {
        path: '/project-info',
        component: PortalLayout,
        children: [
            {
                path: '',
                name: 'Welcome to Project Information Module',
                component: ProjectInfoModule
            },
            {
                path: 'dev-partner',
                component: DevlopmentPartner
            },
            {
                path: 'operation-act',
                component: OperationActivities
            },
            {
                path: 'operation-activities',
                component: OperationActivitiesForm
            },
            {
                path: 'implement-agency',
                component: ImplementingAgency
            },
            {
                path: 'operation-activities-form',
                component: OperationActivitiesForm
            },
            {
                path: 'credit-master',
                component: CreditMaster
            },
            {
                path: 'project-staff-info',
                component: ProjectStaffInformation
            },

            {
                path: 'voucher-type',
                component: VoucherType
            },

            {
                path: 'designation',
                component: Designation
            },
            {
                path: 'agency-details',
                component: AgencyDetails
            },
            {
                path: 'partner-details',
                component: PartnerDetails
            },
            {
                path: 'voucher-master',
                component: VoucherMaster
            },
            {
                path: 'voucher-master-form',
                component: VoucherMasterForm
            },


        ]
    },

    {
        path: '/financial',
        component: PortalLayout,
        children: [
            {
                path: '',
                name: 'Welcome to Financial Management Module',
                component: ProjectInfoModule
            },
            {
                path: 'account-info',
                component: AccountInfo
            },
            {
                path: 'economy-code-info',
                component: EconomyCodeInfo
            },
            {
                path: 'voucher-type',
                component: VoucherType
            },

            {
                path: 'project-budget',
                component: ProjectBudget
            },
            {
                path: 'project-budget-detail',
                component: ProjectBudgetDetail
            },

            {
                path: 'mt-budget-framework',
                component: MidTermProjectBudget
            },
            {
                path: 'mt-budget-framework-detail',
                component: MidTermProjectBudgetDetail
            },

            {
                path: 'yearly-project-budget',
                component: YearlyProjectBudget
            },
            {
                path: 'yearly-pro-budget-detail',
                component: YearlyProjectBudgetDetail
            },
            {
                path: 'project-forecast',
                component: ProjectForcustReport
            },
            {
                path: 'project-yearly-forecast',
                component: ProjectYearlyForecastReport
            },
            {
                path: 'bip-report',
                component: BipReport
            },
            {
                path: 'bip-report/add-new',
                component: BipReportInsertForm
            },
            {
                path: 'budgetWise-fundRelease',
                component: BudgetWiseFundRelease
            },
            {
                path: 'budgetWise-fundRelease/add-new',
                component: BudgetWiseFundReleaseInsertForm
            },
            {
                path: 'voucher-master',
                component: finance_voucher_list
            },
            {
                path: 'voucher-master-form',
                component: FinanceVoucherForm
            },

            {
                path: 'all-voucher-list',
                component: allVoucherList
            },

        ]
    },

    {
        path: '/on-lending',
        component: PortalLayout,

        children: [
            {
                path: '',
                name: 'Welcome to On Lending Module',
                component: ProjectInfoModule
            },
            {
                path: 'sector',
                component: Sector
            },
            {
                path: 'sub-sector',
                component: SubSector
            },
            {
                path: 'pfi-info',
                component: PfiInformation
            },
            {
                path: 're-payment-account-info',
                component: RepaymentAccountInfo
            },
            {
                path: 'client-info',
                component: ClientInformation
            },
            {
                path: 'supplier-info',
                component: Suppliernformation
            },
            {
                path: 'installment-type',
                component: InstallmentType
            },
            {
                path: 'location',
                component: Location
            },
            {
                path: 'sub-project-info',
                component: SubProjectInfo
            },
            {
                path: 'loan-profile',
                component: LoanProfile
            },
            {
                path: 'loan-profile-stepform',
                component: LoanProfActivitiesForm
            },
            {
                path: 'loan-profile-partialgraceperiodform',
                component: LoanProfActivitiesForm
            },

            {
                path: 'loan-profile-detail',
                component: LoanProfileDetail
            },
            {
                path: 'loan-re-schedule-detail',
                component: LoanReScheduleDetail
            },

            {
                path: 'search-disbursement',
                component: SearchDisbursement
            },
            {
                path: 'disbursement',
                component: DisbursementForm
            },
            {
                path: 'payment-schedule',
                component: PaymentSchedule
            },
            {
                path: 'inst-collection',
                component: InstallmentCollection
            },
            {
                path: 're-payment',
                component: RePayment
            },
            /*{
                path: 'overdue-installment', 
                component: OverdueInstallment
            },*/
            {
                path: 'overdue-intnstallment-payment',
                component: OverdueInstallmentPayment
            },

            {
                path: 'early-settlement',
                component: EarlySettlement
            },
            {
                path: 'search-loan-reset',
                component: SearchLoanReset
            },
            {
                path: 'loan-reset',
                component: InsertLoanReset
            },
            {
                path: 'search-loan-reschedule',
                component: SearchLoanReSchedule
            },
            {
                path: 'loan-reschedule',
                component: InsertLoanReSchedule
            },
            {
                path: 'voucher-master',
                component: onlending_voucher_list
            },
            {
                path: 'voucher-master-form',
                component: OnlendingVoucherMasterForm
            },
            {
                path: 'partial-payment',
                component: PartialPay
            },


        ]
    },

    {
        path: '/menu',
        component: PortalLayout,
        children: [{
            path: 'list',
            component: main_menu
        },]
    },
    {
        path: '/setting',
        component: PortalLayout,
        children: [
            {
                path: '',
                name: 'Welcome to On Setting Module',
                component: ProjectInfoModule
            },
        ]
    },

    {
        path: '/oops',
        component: PortalLayout,
        children: [{
            path: '',
            component: Page404
        },]
    },

    {
        path: '/sub-menu',
        component: PortalLayout,
        children: [{
            path: 'list',
            component: sub_menu
        },]
    },

    {
        path: '/security',
        component: LoginLayout,
        children: [{
            path: 'login',
            component: LoginPage
        },
        {
            path: 'logout',
            component: LogoutPage
        },
        ]
    },

    {
        path: '/',
        component: DashboardLayout,
        children: [{
            path: '',
            redirect: '/dashboard'
        },
        {
            path: 'dashboard',
            component: DashboardPage
        },
        ]
    },


    /**
     * ----------------------------------------
     * routes are defined by majeed
     * ----------------------------------------
     */
    {
        path: '/training',
        component: PortalLayout,
        children: [
            {
                path: '',
                name: 'Welcome to Training Administration Module',
                component: ProjectInfoModule
            },
            {
                path: 'cost-head',
                component: TrainingCostHead
            },
            {
                path: 'category',
                component: TrainingCategory
            },
            {
                path: 'organizer-info',
                component: TrainingOrganizerInfo
            },
            {
                path: 'training-info',
                component: TrainingInfo
            },
            {
                path: 'training-info-form',
                component: TrainingInfoForm
            },
            {
                path: 'training-info-details',
                component: TrainingInfoDetails
            },
            {
                path: 'voucher',
                component: TrainingVoucher
            },
            {
                path: 'voucher_master_form',
                component: TrainingVoucherForm
            },
        ]
    },

    {
        path: '/administration',
        component: PortalLayout,
        children: [{
            path: 'sub-head',
            component: SubHead
        },
        {
            path: 'salary-category',
            component: SalaryCategory
        },
        {
            path: 'staff-entry',
            component: StaffEntry
        },
        {
            path: 'overtime-entry',
            component: OvertimeEntry
        },
        {
            path: 'vehicle-entry',
            component: VehicleEntry
        },
        {
            path: 'vehicle-expiry-details',
            component: VehicleExpiry
        },
        {
            path: 'leave-entry',
            component: LeaveEntry
        },
        {
            path: 'personal-leave-tracking',
            component: LeaveDetails
        },
        {
            path: 'leave-tracking-calendar',
            component: LeaveCalendar
        },
        {
            path: 'voucher',
            component: AdminVoucher
        },
        {
            path: 'voucher_master_form',
            component: AdminVoucherForm
        },
        {
            path: 'settings',
            component: admSettings
        },
        {
            path: 'salary-entry',
            component: salaryEntry
        },

        ]
    },

    {
        path: '/document',
        component: PortalLayout,
        children: [{
            path: 'upload',
            component: DocumentInsertForm
        },
        {
            path: 'list',
            component: DocumentList
        },
        {
            path: 'view-list',
            component: ViewDocumentList
        },

        ]
    },

    //################### End Routes by Majeed ###################

    //Procurement routes
    {
        path: '/procurement',
        component: PortalLayout,
        children: [
            {
                path: '',
                name: 'Welcome to Procurement Module',
                component: ProjectInfoModule
            },
            { path: 'method', component: ProcurementMethods },
            { path: 'method_steps', component: ProcurementMethodSteps },
            { path: 'type', component: ProcurementType },
            { path: 'thresholds', component: ProcurementThresholds },
            { path: 'report_note', component: ReportNote },
            { path: 'type_eco', component: ProcurementTypeEco },
            { path: 'status', component: ProcurementStatus },
            { path: 'unit_master', component: ProcurementUnit },
            { path: 'contract', component: ProcurementContract },
            { path: 'supplier', component: ProcurementSupplier },
            { path: 'package', component: ProcurementPackage },
            { path: 'new_package', component: ProcurementNewPackage },
            { path: 'package_revision', component: ProcurementPackageRev },
            { path: 'new_revision', component: ProcurementRevision },
            { path: 'package_execution', component: ProcurementExecution },
            { path: 'executions', component: ProcurementExecutions },
            { path: 'execution_form', component: ProcurementExecutionForm },
            { path: 'voucher', component: ProcurementVoucher },
            { path: 'voucher_form', component: ProcVoucherMasterForm },
            { path: 'package-version', component: PackageVersion },

            { path: 'archive-list', component: PackageArchive },
            { path: 'archive-details', component: PackageArchiveDetails },
            { path: 'package-details', component: PackageVieweDetails },
            { path: 'execution-details', component: ExecutionVieweDetails },


        ]
    },

    {
        path: '/asset',
        component: PortalLayout,
        children: [
            {
                path: '',
                name: 'Welcome to Asset Module',
                component: ProjectInfoModule
            },
            {
                path: 'sub_category',
                component: AssetSubCategory
            },
            {
                path: 'category',
                component: AssetCategory
            },
            {
                path: 'item',
                component: AssetItem
            },
            {
                path: 'location',
                component: AssetLocation
            },
            {
                path: 'master',
                component: AssetMaster
            },
            {
                path: 'movement',
                component: AssetMovement
            },

        ]
    },

    {
        path: '/report',
        component: PortalLayout,
        children: [
            {
                path: '',
                name: 'Welcome to Report Module',
                component: ProjectInfoModule
            },
            {
                path: 'parameter_master',
                component: ParameterMaster
            },
            {
                path: 'master',
                component: ReportMaster
            },
            {
                path: 'details',
                component: ReportDetails
            },
            {
                path: 'interface',
                component: ReportInterface
            },
            {
                path: 'audit_details',
                component: AuditDetails
            },



        ]
    },
    {
        path: '/asset',
        component: PortalLayout,
        children: [
            {
                path: '',
                name: 'Welcome to Asset Module',
                component: ProjectInfoModule
            },
            {
                path: 'sub_category',
                component: AssetSubCategory
            },
            {
                path: 'category',
                component: AssetCategory
            },
            {
                path: 'item',
                component: AssetItem
            },
            {
                path: 'location',
                component: AssetLocation
            },
            {
                path: 'master',
                component: AssetMaster
            },
            {
                path: 'movement',
                component: AssetMovement
            },

        ]
    },

    {
        path: '*',
        component: PortalLayout,
        children: [{
            path: 'category',
            component: TrainingCategory
        },

        ]
    },

]

const router = new VueRouter({
    mode: 'hash',
    //mode: 'history',
    scrollBehavior: () => ({
        y: 0
    }),
    routes, // short for routes: route
})
const lStore = store;

router.beforeEach((to, from, next) => {

    //console.log("to "+to.path+" from "+from.path)

    const portalUrls = to.path.substring(1).split('/');

    if (sessionStorage.getItem("auth") != 'yes') {
        if (to.path == "/security/login" || portalUrls[0] == "portal")
            next(true)
        else next({
            path: '/security/login'
        })
    } else if (sessionStorage.getItem("auth") == 'yes' && to.path == "/security/login") {
        next({
            path: '/'
        })
    } else if (sessionStorage.getItem("auth") == 'yes' && to.path == "/security/logout") {
        next(true)
    } else if (sessionStorage.getItem("auth") == 'yes' && to.path == "/oops") {
        next(true)
    } else if (portalUrls[0] == "portal") {
        next(true)
    } //else next(true)

    else {

        //console.log('to.path', to.path);

        var storeUrl = []

        let menuUrl = [];
        let url = sessionStorage.getItem("m")
        if (url) {
            menuUrl = JSON.parse(Encrypted.base64_decode(url));
        }
        var yes_url = menuUrl.indexOf(to.path);

        let defaultUrl = utilities.defaultUrl();
        var defaultUrlVal = defaultUrl.indexOf(to.path);

        if (yes_url != -1 || defaultUrlVal != -1) {
            next(true);
        }
        else {
            if (performance.navigation.type == 1) {
                next(true);
            }
            else {
                //next({path: '/oops'}) 
                next(true);
            }
        }
    }

})

export default router



// WEBPACK FOOTER //
// ./src/router.js